<template>
  <div ref="viewport" class="hvac-floor-viewport">
    <div class="hvac-floor-board" :style="boardStyle">
      <img class="hvac-floor-image" :src="floorImage" alt="南都10F原始平面底图，保留实际墙体、走廊与楼梯结构" draggable="false">
      <template v-for="zone in zones">
        <button :key="zone.id" class="hvac-room" :class="[heatVisible ? tone(temperatureOf(zone)) : 'state-only', { selected: selected === zone.id, realtime: hasRealtime(zone) }]" :style="zoneStyle(zone)" :aria-pressed="selected === zone.id" :aria-label="zone.name + '，' + temperatureLabel(zone) + '，查看区域详情'" @click="$emit('select', zone.id)">
          <span class="hvac-room-name">{{ zone.name }}</span><em v-if="hasRealtime(zone)" class="hvac-room-live">实时</em><span class="hvac-room-temperature">{{ temperatureLabel(zone) }}</span>
        </button>
        <button v-for="(device, index) in zoneDevices(zone)" :key="device.id" class="hvac-map-device" :class="[state(device), { 'has-attention': !device.online }]" :style="deviceStyle(zone, index)" :aria-label="zone.name + '，' + device.name + '，' + stateNames[state(device)] + '，查看设备'" :title="zone.name + ' · ' + device.name + ' · ' + stateNames[state(device)]" @click.stop="$emit('device', device)">
          <i class="el-icon-monitor" aria-hidden="true" /><span>{{ index + 1 }}</span><i v-if="!device.online" class="hvac-device-alert el-icon-warning-outline" />
        </button>
      </template>
    </div>
  </div>
</template>
<script>
import floorImage from './assets/nandu10-hvac-gray.png'
import { AIR_MAP_SIZE, AIR_ZONES, AIR_STATE_NAMES, airState, airTemperatureTone } from './air-model'

export default {
  name: 'AirFloorMap',
  props: { devices: { type: Array, required: true }, snapshot: { type: Number, required: true }, selected: { type: String, default: '' }, heatVisible: { type: Boolean, default: true }, zoneTemperatures: { type: Object, default: () => ({}) } },
  data () { return { floorImage, zones: AIR_ZONES, stateNames: AIR_STATE_NAMES, boardWidth: 0 } },
  computed: { boardStyle () { return { width: this.boardWidth + 'px', height: this.boardWidth * AIR_MAP_SIZE.height / AIR_MAP_SIZE.width + 'px' } } },
  mounted () {
    this.fitBoard(this.$refs.viewport.clientWidth, this.$refs.viewport.clientHeight)
    this.observer = new ResizeObserver(entries => {
      const rect = entries[0].contentRect
      this.fitBoard(rect.width, rect.height)
    })
    this.observer.observe(this.$refs.viewport)
  },
  beforeDestroy () { if (this.observer) this.observer.disconnect() },
  methods: {
    fitBoard (width, height) {
      // Preserve the last valid size while an unopened floor hides the map.
      if (width <= 0 || height <= 0) return
      const next = Math.floor(Math.min(width, height * AIR_MAP_SIZE.width / AIR_MAP_SIZE.height) * 100) / 100
      if (Math.abs(this.boardWidth - next) >= 0.01) this.boardWidth = next
    },
    state: airState,
    tone: airTemperatureTone,
    zoneDevices (zone) { return this.devices.filter(device => device.zoneId === zone.id) },
    hasRealtime (zone) { return this.zoneTemperatures && this.zoneTemperatures[zone.id] != null },
    temperatureOf (zone) {
      const override = this.zoneTemperatures ? this.zoneTemperatures[zone.id] : null
      return override != null ? override : zone.temperatures[this.snapshot]
    },
    temperatureLabel (zone) { const value = this.temperatureOf(zone); return value == null ? '无测温' : value.toFixed(1) + '°C' },
    zoneStyle (zone) {
      const [x, y, width, height] = zone.rect
      return { left: x / AIR_MAP_SIZE.width * 100 + '%', top: y / AIR_MAP_SIZE.height * 100 + '%', width: width / AIR_MAP_SIZE.width * 100 + '%', height: height / AIR_MAP_SIZE.height * 100 + '%' }
    },
    deviceStyle (zone, index) {
      const [x, y, width, height] = zone.rect
      const position = zone.positions ? zone.positions[index] : [index ? 0.64 : 0.36, 0.52]
      return { left: (x + width * position[0]) / AIR_MAP_SIZE.width * 100 + '%', top: (y + height * position[1]) / AIR_MAP_SIZE.height * 100 + '%' }
    }
  }
}
</script>
